import { ark } from '@ark-ui/react';
import {
  styled,
  iconButton,
  type ComponentProps,
} from '@terra/ui-styled-system';

export const IconButton = styled(ark.button, iconButton);
export type IconButtonStyledProps = ComponentProps<typeof IconButton>;
export type IconButtonSize = NonNullable<IconButtonStyledProps['size']>;
